<template>
    <b-modal
        id="change-mobile-number-generic-modal"
        hide-header
        footer-class="border-top-0 justify-content-center"
        body-class="pt-5 px-5"
        centered>
        <h5 class="text-center">
            {{ success ? 'Success!' : 'Oops!' }}
        </h5>
        <p class="text-center">{{ modalMessage }}</p>
        <template v-slot:modal-footer>
            <b-button variant="primary" class="px-5 border-0"
                @click="hideModal"
                pill
                :style="{
                    'background-color': webDesign && webDesign.design ? webDesign.design.main_color : null,
                    'color': webDesign && webDesign.design ? webDesign.design.button_text_color : null
                }">
                Close
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'ChangeMobileNumberGenericModal',
    props: ['modalMessage', 'webDesign', 'success'],
    methods: {
        hideModal() {
            if (this.success) {
                this.$emit('change-component', 'Details')
            }
            this.$bvModal.hide('change-mobile-number-generic-modal');
        }
    }
}
</script>

<style lang="scss">
#change-mobile-number-generic-modal {
    .modal-dialog {
        max-width: 500px !important;
    }
}
</style>
